import { Component } from '@angular/core';
import { WorkflowItemQueriesService } from '@workflow/queries/services/workflow-item-queries.service';

@Component({
	selector: 'workflow-query-create',
	templateUrl: './query-create.component.html',
	styleUrls: ['./query-create.component.scss'],
})
export class QueryCreateComponent {
	public key?: string;
	public message?: string;
	
	constructor(private readonly workflowItemQueriesService: WorkflowItemQueriesService) { }
	
	public async create(): Promise<void> {
		if (typeof this.message === 'string') {
			await this.workflowItemQueriesService.create(this.message, typeof this.key === 'string' ? this.key : undefined);
			
			this.message = null;
			this.key = null;
		}
	}
}
